import React from 'react';
import styled from 'styled-components';

const SectionTitle = ({ title, subtitle, centered = true, light = false }) => {
  return (
    <TitleContainer $centered={centered}>
      <Title $light={light}>{title}</Title>
      {subtitle && <Subtitle $light={light}>{subtitle}</Subtitle>}
    </TitleContainer>
  );
};

const TitleContainer = styled.div`
  margin-bottom: 3rem;
  text-align: ${({ $centered }) => ($centered ? 'center' : 'left')};
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: ${({ theme, $light }) => 
    $light ? theme.colors.text.primary : theme.colors.text.dark};
  margin-bottom: 1rem;
  position: relative;
  display: inline-block;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 3px;
    background-color: ${({ theme }) => theme.colors.primary};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 2rem;
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: 1.75rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: ${({ theme, $light }) => 
    $light ? theme.colors.text.secondary : theme.colors.text.muted};
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 1rem;
  }
`;

export default SectionTitle;
